import round from 'lodash.round';

import { DEFAULT_TEXT_ELEMENT_COPY } from 'js/config/consts';
import { textCharacterAnimationTime } from 'js/shared/resources/scribedefaults';
import { ExistingScribeModel, VSElementModel } from 'js/types';
import ScribeTextElementModel from 'js/models/ScribeTextElementModel';

export const updateElementsInScene = (newActiveScribe: ExistingScribeModel, elements: Array<VSElementModel>) => {
  const allElements = newActiveScribe.elements;
  const activeScene = newActiveScribe.scenes.find(scene => scene.active === true);

  if (!activeScene) return newActiveScribe;

  for (const element of elements) {
    const existingElementIndex = allElements.findIndex(el => el.id === element.id);
    const existingSceneElementIndex = activeScene.elementIds.findIndex(el => el === element.id);
    const existingElement = allElements[existingElementIndex];
    const existingElementText = (existingElement as ScribeTextElementModel)?.text || '';

    if (existingElementIndex === -1) {
      allElements.push(element);
    } else if (
      element.type === 'Text' &&
      existingElementText === DEFAULT_TEXT_ELEMENT_COPY &&
      element.text !== DEFAULT_TEXT_ELEMENT_COPY &&
      element.text?.trim().length
    ) {
      element.animationTime =
        element.animationTime !== undefined
          ? element.animationTime
          : round(element.text.trim().replace(/\s/g, '').length * textCharacterAnimationTime, 1);

      allElements[existingElementIndex] = element;
    } else if (element.type === 'Text' && !element.text?.trim().length) {
      allElements.splice(existingElementIndex, 1);
      activeScene.elementIds.splice(existingSceneElementIndex, 1);
    } else {
      allElements[existingElementIndex] = element;
    }
  }

  return newActiveScribe;
};
